import { Box } from '@amzn/awsui-components-core';
import React from 'react';
import LoadingPage from './LoadingPage';

interface Props {
  headerText?: string;
  showLoadingIndicator: boolean;
  children?: React.ReactNode;
}

const TransparentPageCanvas: React.FC<Props> = ({ showLoadingIndicator, children }) => {
  return <Box padding="xl">{showLoadingIndicator ? <LoadingPage /> : children}</Box>;
};

export default TransparentPageCanvas;
